$(document).ready(function () {
	let $html = $('html');

	if ($html.attr('id') !== 'article-detail') {
		return;
	}

	$(document).on('click', '#increaseNumberOfLikes', function () {
		$.get($(this).data('ajax-action'), function (data) {
			Object.keys(data.snippets).forEach(function (key) {
				$('#' + key).html(data.snippets[key]);
			});
		});

		return false;
	});
});

$(document).ready(function () {
	let anchorReading = $('anchor-reading');

	if (anchorReading.length === 0) {
		return;
	}

	if (typeof IntersectionObserver === 'function') {
		let observer = new IntersectionObserver(function (list) {
			$.each(list, function (index, item) {
				if ((item.isIntersecting === undefined && item.intersectionRatio > 0) || item.isIntersecting) {
					observer.unobserve(item.target);
					let $item = $(item.target);
					$.get($item.data('ajax-action'));
				}
			});
		}, {rootMargin: '0px', threshold: 0.5});

		observer.observe(anchorReading[0]);
	}
	else {
		$.get(anchorReading.data('ajax-action'));
	}
});
